import { observer } from 'mobx-react';
import React from 'react';

import { Grid } from '@mui/material';
import Page from 'components/Page';

import AvatarUserData from '../components/AvatarUserData';
import Banner from '../components/Banner';
import InfoBlockList from '../components/InfoBlockList';

function ProfilePage() {
	return (
		<Page type="list" sx={{ overflow: 'hidden' }}>
			<Banner />
			<AvatarUserData />
			<Grid item xs={12}>
				<InfoBlockList />
			</Grid>
		</Page>
	);
}

export default observer(ProfilePage);
